import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';
import { PaymentRequest } from '../model/payment-request';
import { CommissionService } from './commission.service';
import { List } from 'immutable';
import { Attachment } from '../../event/models/attachment';

@Injectable()
export class CommissionStore {

  private _paymentRequest: BehaviorSubject<PaymentRequest> = new BehaviorSubject(new PaymentRequest());
  get paymentRequest(): Observable<PaymentRequest> {
    return this._paymentRequest.asObservable();
  }

  private _attachments: BehaviorSubject<List<Attachment>> = new BehaviorSubject(List([]));

  get attachments(): Observable<any> {
    return this._attachments.asObservable();
  }

  private _errorResponse: BehaviorSubject<HttpErrorResponse> = new BehaviorSubject(null);
  get errorResponse(): Observable<HttpErrorResponse> {
    return this._errorResponse.asObservable();
  }

  constructor(
    private commissionService: CommissionService,
    private router: Router,
  ) {
  }

  loadPaymentRequestDetails() {
    return this.commissionService.getPaymentRequestDetails()
      .catch(err => this.handleError(err))
      .pipe(map((res: PaymentRequest) => this._paymentRequest.next(res)));
  }

  private handleError(error: HttpErrorResponse): Observable<any> {
    this._errorResponse.next(error);
    this.router.navigate(['payment/error']);

    return Observable.empty();
  }

  addAttachment(eventId: number, eventPartyId: number, file: File, multiVendor: boolean): Observable<any> {
    return this.commissionService.addAttachment(eventId, eventPartyId, file, multiVendor)
      .map((res) => {
        this._attachments.next(JSON.parse(res._body));
      });
  }

  getAttachment(uniqueId: string): Observable<string> {
    return this.commissionService.getAttachment(uniqueId)
      .map((response: any) => {
        window.open(response);
        return response;
      })
      .catch(error => Observable.throw(error)).share();
  }

  deleteAttachment(eventId: number, eventPartyId: number, uniqueId: string, multiVendor: boolean): Observable<any> {
    return this.commissionService.deleteAttachment(uniqueId)
      .map((res) => {
        this._attachments.next(List([]));
      });
  }

  getFile(file: File, name: string) {
    return new File([file], name, {type: file.type});
  }

  isResendPaymentRequestAllowed(): Observable<{ resendPaymentRequestAllowed: boolean; }> {
    return this.commissionService.isResendPaymentRequestAllowed();
  }

  resendPaymentRequest(): Observable<{}> {
    return this.commissionService.resendPaymentRequest();
  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/payment/service/commission.store.ts